// input: GenericProducts
// output: Products,  CombinedProducts

import { ProductBasic } from "../model/ProductBasic";

// Normal products are products that are not part of any combined products.
export enum ProductTypes {
  Product = "Product",
  Combine = "Combine",
}

export default function getCombinedProductsAndProducts(products: any) {
  const combinedProducts = Array.isArray(products)
    ? products
        .filter((product) => product?.contentType === ProductTypes.Combine)
        .filter(Boolean)
    : [];

  const combinedProductIds = new Set<number>();
  for (const combined of combinedProducts) {
    for (const product of combined.contentObject.products) {
      combinedProductIds.add(product.omniwebId);
    }
  }

  const _products = Array.isArray(products) ? products.filter(Boolean) : [];

  const nonCombinedProducts = _products.filter(
    (product) => !combinedProductIds.has(product.contentObject.omniwebId)
  );

  return {
    combinedProductIds,
    combinedProducts: combinedProducts as ProductBasic[],
    nonCombinedProducts,
    products: _products,
  };
}
